import type { CollectableItem } from "../collectableItem";
import { deserializeItem, deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { LootBox } from "./lootBox";

export class KeyLootBox extends LootBox {
	static key = "KeyLootBox";
	constructor(xy: XY, loot?: CollectableItem[]) {
		super(xy, loot);
	}

	static deserialize(data: any): KeyLootBox {
		const box = new KeyLootBox(deserializeXY(data.xy));
		box.visualId = data.visualId;
		if (data.loot) {
			box.loot = data.loot.map((d: any) => deserializeItem(d));
		}
		return box;
	}
}
